/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  CreateLadderBody,
  CreateLadderResponse,
  DeleteLadderResponse,
  GetLadderParticipantsResponse,
  GetLadderResponse,
  GetLadderStandingsResponse,
  GetLaddersResponse,
  GetLaddersSort,
  GetPublicLadderResponse,
  GetPublicLaddersResponse,
  GetPublicLaddersSort,
  GetStandingsSort,
  JoinLadderBody,
  JoinLadderResponse,
  LadderParticipantStatus,
  LadderStatus,
  SortOrder,
  UpdateLadderBody,
  UpdateLadderResponse,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    CreateLadderBodyFromJSON,
    CreateLadderBodyToJSON,
    CreateLadderResponseFromJSON,
    CreateLadderResponseToJSON,
    DeleteLadderResponseFromJSON,
    DeleteLadderResponseToJSON,
    GetLadderParticipantsResponseFromJSON,
    GetLadderParticipantsResponseToJSON,
    GetLadderResponseFromJSON,
    GetLadderResponseToJSON,
    GetLadderStandingsResponseFromJSON,
    GetLadderStandingsResponseToJSON,
    GetLaddersResponseFromJSON,
    GetLaddersResponseToJSON,
    GetLaddersSortFromJSON,
    GetLaddersSortToJSON,
    GetPublicLadderResponseFromJSON,
    GetPublicLadderResponseToJSON,
    GetPublicLaddersResponseFromJSON,
    GetPublicLaddersResponseToJSON,
    GetPublicLaddersSortFromJSON,
    GetPublicLaddersSortToJSON,
    GetStandingsSortFromJSON,
    GetStandingsSortToJSON,
    JoinLadderBodyFromJSON,
    JoinLadderBodyToJSON,
    JoinLadderResponseFromJSON,
    JoinLadderResponseToJSON,
    LadderParticipantStatusFromJSON,
    LadderParticipantStatusToJSON,
    LadderStatusFromJSON,
    LadderStatusToJSON,
    SortOrderFromJSON,
    SortOrderToJSON,
    UpdateLadderBodyFromJSON,
    UpdateLadderBodyToJSON,
    UpdateLadderResponseFromJSON,
    UpdateLadderResponseToJSON,
} from '../models/index';

export interface CreateLaddersRequest {
    createLadderBody?: CreateLadderBody;
}

export interface CreateLaddersIdParticipantsRequest {
    id: string;
    joinLadderBody?: JoinLadderBody;
}

export interface DeleteLaddersIdRequest {
    id: string;
}

export interface GetLaddersRequest {
    status?: LadderStatus;
    search?: string;
    gameId?: string;
    sort?: GetLaddersSort;
    order?: SortOrder;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetLaddersIdRequest {
    id: string;
}

export interface GetLaddersIdParticipantsRequest {
    id: string;
    search?: string;
    status?: LadderParticipantStatus;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetLaddersIdStandingsRequest {
    id: string;
    sort?: GetStandingsSort;
    order?: SortOrder;
    status?: LadderParticipantStatus;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetPublicLaddersRequest {
    status?: LadderStatus;
    gameId?: string;
    ids?: string;
    sort?: GetPublicLaddersSort;
    order?: SortOrder;
    limit?: number;
    offset?: number;
}

export interface GetPublicLaddersIdRequest {
    id: string;
}

export interface UpdateLaddersIdRequest {
    id: string;
    updateLadderBody?: UpdateLadderBody;
}

/**
 * LaddersApi - interface
 * 
 * @export
 * @interface LaddersApiInterface
 */
export interface LaddersApiInterface {
    /**
     * 
     * @param {CreateLadderBody} [createLadderBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaddersApiInterface
     */
    createLaddersRaw(requestParameters: CreateLaddersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLadderResponse>>;

    /**
     */
    createLadders(requestParameters: CreateLaddersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLadderResponse>;

    /**
     * 
     * @param {string} id 
     * @param {JoinLadderBody} [joinLadderBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaddersApiInterface
     */
    createLaddersIdParticipantsRaw(requestParameters: CreateLaddersIdParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JoinLadderResponse>>;

    /**
     */
    createLaddersIdParticipants(requestParameters: CreateLaddersIdParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<JoinLadderResponse>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaddersApiInterface
     */
    deleteLaddersIdRaw(requestParameters: DeleteLaddersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteLadderResponse>>;

    /**
     */
    deleteLaddersId(requestParameters: DeleteLaddersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteLadderResponse>;

    /**
     * 
     * @param {LadderStatus} [status] 
     * @param {string} [search] 
     * @param {string} [gameId] 
     * @param {GetLaddersSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaddersApiInterface
     */
    getLaddersRaw(requestParameters: GetLaddersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLaddersResponse>>;

    /**
     */
    getLadders(requestParameters: GetLaddersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLaddersResponse>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaddersApiInterface
     */
    getLaddersIdRaw(requestParameters: GetLaddersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLadderResponse>>;

    /**
     */
    getLaddersId(requestParameters: GetLaddersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLadderResponse>;

    /**
     * Get all participants for a ladder with pagination and filtering (admin only)
     * @param {string} id 
     * @param {string} [search] Filter by display name
     * @param {LadderParticipantStatus} [status] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaddersApiInterface
     */
    getLaddersIdParticipantsRaw(requestParameters: GetLaddersIdParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLadderParticipantsResponse>>;

    /**
     * Get all participants for a ladder with pagination and filtering (admin only)
     */
    getLaddersIdParticipants(requestParameters: GetLaddersIdParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLadderParticipantsResponse>;

    /**
     * 
     * @param {string} id 
     * @param {GetStandingsSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {LadderParticipantStatus} [status] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaddersApiInterface
     */
    getLaddersIdStandingsRaw(requestParameters: GetLaddersIdStandingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLadderStandingsResponse>>;

    /**
     */
    getLaddersIdStandings(requestParameters: GetLaddersIdStandingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLadderStandingsResponse>;

    /**
     * 
     * @param {LadderStatus} [status] 
     * @param {string} [gameId] 
     * @param {string} [ids] Comma-separated list of ladder IDs to filter by
     * @param {GetPublicLaddersSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaddersApiInterface
     */
    getPublicLaddersRaw(requestParameters: GetPublicLaddersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPublicLaddersResponse>>;

    /**
     */
    getPublicLadders(requestParameters: GetPublicLaddersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPublicLaddersResponse>;

    /**
     * Returns a ladder\'s details. Only returns ACTIVE ladders for public visibility.
     * @summary Get a single ladder by ID (public)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaddersApiInterface
     */
    getPublicLaddersIdRaw(requestParameters: GetPublicLaddersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPublicLadderResponse>>;

    /**
     * Returns a ladder\'s details. Only returns ACTIVE ladders for public visibility.
     * Get a single ladder by ID (public)
     */
    getPublicLaddersId(requestParameters: GetPublicLaddersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPublicLadderResponse>;

    /**
     * 
     * @param {string} id 
     * @param {UpdateLadderBody} [updateLadderBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaddersApiInterface
     */
    updateLaddersIdRaw(requestParameters: UpdateLaddersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateLadderResponse>>;

    /**
     */
    updateLaddersId(requestParameters: UpdateLaddersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateLadderResponse>;

}

/**
 * 
 */
export class LaddersApi extends runtime.BaseAPI implements LaddersApiInterface {

    /**
     */
    async createLaddersRaw(requestParameters: CreateLaddersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLadderResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ladders`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLadderBodyToJSON(requestParameters['createLadderBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLadderResponseFromJSON(jsonValue));
    }

    /**
     */
    async createLadders(requestParameters: CreateLaddersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLadderResponse> {
        const response = await this.createLaddersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createLaddersIdParticipantsRaw(requestParameters: CreateLaddersIdParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JoinLadderResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createLaddersIdParticipants().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ladders/{id}/participants`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JoinLadderBodyToJSON(requestParameters['joinLadderBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JoinLadderResponseFromJSON(jsonValue));
    }

    /**
     */
    async createLaddersIdParticipants(requestParameters: CreateLaddersIdParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<JoinLadderResponse> {
        const response = await this.createLaddersIdParticipantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteLaddersIdRaw(requestParameters: DeleteLaddersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteLadderResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteLaddersId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ladders/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteLadderResponseFromJSON(jsonValue));
    }

    /**
     */
    async deleteLaddersId(requestParameters: DeleteLaddersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteLadderResponse> {
        const response = await this.deleteLaddersIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLaddersRaw(requestParameters: GetLaddersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLaddersResponse>> {
        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['gameId'] != null) {
            queryParameters['gameId'] = requestParameters['gameId'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ladders`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLaddersResponseFromJSON(jsonValue));
    }

    /**
     */
    async getLadders(requestParameters: GetLaddersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLaddersResponse> {
        const response = await this.getLaddersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLaddersIdRaw(requestParameters: GetLaddersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLadderResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getLaddersId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ladders/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLadderResponseFromJSON(jsonValue));
    }

    /**
     */
    async getLaddersId(requestParameters: GetLaddersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLadderResponse> {
        const response = await this.getLaddersIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all participants for a ladder with pagination and filtering (admin only)
     */
    async getLaddersIdParticipantsRaw(requestParameters: GetLaddersIdParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLadderParticipantsResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getLaddersIdParticipants().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ladders/{id}/participants`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLadderParticipantsResponseFromJSON(jsonValue));
    }

    /**
     * Get all participants for a ladder with pagination and filtering (admin only)
     */
    async getLaddersIdParticipants(requestParameters: GetLaddersIdParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLadderParticipantsResponse> {
        const response = await this.getLaddersIdParticipantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLaddersIdStandingsRaw(requestParameters: GetLaddersIdStandingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLadderStandingsResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getLaddersIdStandings().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/ladders/{id}/standings`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLadderStandingsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getLaddersIdStandings(requestParameters: GetLaddersIdStandingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLadderStandingsResponse> {
        const response = await this.getLaddersIdStandingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPublicLaddersRaw(requestParameters: GetPublicLaddersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPublicLaddersResponse>> {
        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['gameId'] != null) {
            queryParameters['gameId'] = requestParameters['gameId'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/public/ladders`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPublicLaddersResponseFromJSON(jsonValue));
    }

    /**
     */
    async getPublicLadders(requestParameters: GetPublicLaddersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPublicLaddersResponse> {
        const response = await this.getPublicLaddersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a ladder\'s details. Only returns ACTIVE ladders for public visibility.
     * Get a single ladder by ID (public)
     */
    async getPublicLaddersIdRaw(requestParameters: GetPublicLaddersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPublicLadderResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getPublicLaddersId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/public/ladders/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPublicLadderResponseFromJSON(jsonValue));
    }

    /**
     * Returns a ladder\'s details. Only returns ACTIVE ladders for public visibility.
     * Get a single ladder by ID (public)
     */
    async getPublicLaddersId(requestParameters: GetPublicLaddersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPublicLadderResponse> {
        const response = await this.getPublicLaddersIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateLaddersIdRaw(requestParameters: UpdateLaddersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateLadderResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateLaddersId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ladders/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLadderBodyToJSON(requestParameters['updateLadderBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateLadderResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateLaddersId(requestParameters: UpdateLaddersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateLadderResponse> {
        const response = await this.updateLaddersIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
